/* Échiquier Boutique — scripts d'optimisation ajoutés par Claude (aucune dépendance). */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  function isFr() { return (document.documentElement.lang || 'fr').indexOf('fr') === 0; }

  /* 1. Fiche produit : variantes en boutons (jusqu'à 6 choix), le menu déroulant reste la source de vérité */
  function initPills() {
    var selects = document.querySelectorAll('.template-product .selector-wrapper select.single-option-selector');
    Array.prototype.forEach.call(selects, function (sel) {
      if (sel.options.length < 2 || sel.options.length > 6 || sel.getAttribute('data-eb-pills')) { return; }
      sel.setAttribute('data-eb-pills', '1');
      var wrap = sel.parentNode;
      wrap.classList.add('eb-has-pills');
      var box = document.createElement('div');
      box.className = 'eb-pills';
      box.setAttribute('role', 'group');
      box.setAttribute('aria-label', sel.getAttribute('data-name') || 'Options');
      function sync() {
        Array.prototype.forEach.call(box.children, function (b, i) {
          b.setAttribute('aria-pressed', sel.selectedIndex === i ? 'true' : 'false');
        });
      }
      Array.prototype.forEach.call(sel.options, function (opt, idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'eb-pill';
        b.textContent = opt.textContent.trim();
        b.setAttribute('aria-pressed', opt.selected ? 'true' : 'false');
        b.addEventListener('click', function () {
          sel.selectedIndex = idx;
          sync();
          try {
            if (window.jQuery) { window.jQuery(sel).trigger('change'); }
            else { sel.dispatchEvent(new Event('change', { bubbles: true })); }
          } catch (e) {}
          sync();
        });
        box.appendChild(b);
      });
      sel.addEventListener('change', sync);
      wrap.appendChild(box);
    });
  }

  /* 2. Panier : mise à jour de la barre « livraison offerte » quand les quantités changent */
  function initCartBar() {
    var bar = document.getElementById('eb-ship');
    if (!bar) { return; }
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 9900;
    var msg = document.getElementById('eb-ship-msg');
    var fill = document.getElementById('eb-ship-fill');
    function euros(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
    function refresh() {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var total = cart.total_price;
        fill.style.width = Math.min(100, Math.round(total * 100 / threshold)) + '%';
        msg.innerHTML = total >= threshold
          ? '<strong>Livraison offerte</strong> pour cette commande.'
          : 'Plus que <strong>' + euros(threshold - total) + '</strong> pour profiter de la <strong>livraison offerte</strong>.';
      }).catch(function () {});
    }
    refresh();
    var target = document.getElementById('CartFooter') || document.getElementById('CartSubtotal');
    if (target && window.MutationObserver) {
      new MutationObserver(function () { refresh(); }).observe(target, { childList: true, subtree: true, characterData: true });
    }
  }

  /* 3. Blog : « Afficher plus d'articles » (tous les articles sont déjà dans la page) */
  function initBlogMore() {
    var btn = document.getElementById('eb-blog-more');
    if (!btn) { return; }
    var step = parseInt(btn.getAttribute('data-step'), 10) || 12;
    btn.addEventListener('click', function () {
      var hidden = document.querySelectorAll('#eb-blog-grid .eb-post.is-hidden');
      for (var i = 0; i < hidden.length && i < step; i++) { hidden[i].classList.remove('is-hidden'); }
      if (hidden.length <= step) { btn.parentNode.style.display = 'none'; }
    });
  }

  /* 4. Accueil sur téléphone : les longs blocs de texte sont repliés (le texte reste dans la page) */
  function initClamp() {
    if (!document.body.classList.contains('template-index') || window.innerWidth > 749) { return; }
    var blocks = document.querySelectorAll('.index-section .rte, .index-section .rte-setting');
    Array.prototype.forEach.call(blocks, function (el) {
      if (el.closest('.eb-section') || el.querySelector('.eb-hero, h3[onclick], .eb-clamp') || el.closest('.eb-clamp') || el.getAttribute('data-eb-clamp')) { return; }
      if (el.scrollHeight < 420) { return; }
      el.setAttribute('data-eb-clamp', '1');
      el.classList.add('eb-clamp');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'eb-clamp-btn';
      b.textContent = 'Lire la suite';
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var open = el.classList.toggle('is-open');
        b.textContent = open ? 'Réduire' : 'Lire la suite';
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      el.parentNode.insertBefore(b, el.nextSibling);
    });
  }

  /* 5. Fiche produit : libellé des variantes + lignes de réassurance sous le bouton d'achat */
  function initPdp() {
    if (!document.body.classList.contains('template-product')) { return; }
    var fr = isFr();
    var selects = document.querySelectorAll('.selector-wrapper select.single-option-selector');
    Array.prototype.forEach.call(selects, function (sel) {
      var wrap = sel.parentNode;
      if (wrap.querySelector('label')) { return; }
      var name = sel.getAttribute('data-name');
      if (!name || /^(title|default)$/i.test(name)) { return; }
      var lab = document.createElement('label');
      lab.setAttribute('for', sel.id);
      lab.textContent = name;
      wrap.insertBefore(lab, wrap.firstChild);
    });
    var rows = document.querySelectorAll('.product-single__info-wrapper .product-extra-row');
    if (rows.length && !document.querySelector('.eb-pdp-help')) {
      var last = rows[rows.length - 1];
      var li = document.createElement('li');
      li.className = 'product-extra-row eb-row-return';
      li.innerHTML = fr
        ? '<span><i class="demo-icon icon-ok-circled">&#xe802;</i> Satisfait ou remboursé · <a href="/pages/politique-remboursement">conditions de retour</a></span>'
        : '<span><i class="demo-icon icon-ok-circled">&#xe802;</i> Money-back guarantee · <a href="/pages/politique-remboursement">return policy</a></span>';
      last.parentNode.insertBefore(li, last.nextSibling);
      var help = document.createElement('li');
      help.className = 'eb-pdp-help';
      help.innerHTML = fr
        ? 'Une question avant de commander ? <a href="/pages/contact">Écrivez-nous</a> : réponse sous 24 h, du lundi au vendredi.'
        : 'A question before ordering? <a href="/pages/contact">Contact us</a>: reply within 24 hours, Monday to Friday.';
      li.parentNode.insertBefore(help, li.nextSibling);
    }
    var relTitle = document.querySelector('.eb-related__title');
    if (relTitle && !fr) { relTitle.textContent = 'You may also like'; }
  }

  /* 6. Panier : barre « livraison offerte », réassurance et lien de retour, ajoutés sans toucher au modèle du panier */
  function initCartExtras() {
    if (!document.body.classList.contains('template-cart')) { return; }
    var form = document.querySelector('form.cart');
    if (!form || document.getElementById('eb-ship')) { return; }
    var country = (window.Shopify && window.Shopify.country) || 'FR';
    var fr = isFr();
    var bar = document.createElement('div');
    bar.className = 'eb-ship';
    if (country === 'FR' && fr) {
      bar.id = 'eb-ship';
      bar.setAttribute('data-threshold', '9900');
      bar.innerHTML = '<p class="eb-ship__msg" id="eb-ship-msg">&nbsp;</p><div class="eb-ship__bar"><span id="eb-ship-fill" style="width:0%"></span></div>' +
        '<p class="eb-ship__note">Livraison suivie en France métropolitaine : 7,90 € en dessous de 99 €, offerte à partir de 99 €. Expédition sous 24/48 h.</p>';
    } else {
      bar.innerHTML = '<p class="eb-ship__msg">' + (fr ? 'Frais de livraison : France 7,90 € (offerte dès 99 €) · Europe 19 € · Suisse 29 € · autres pays 49 €.' : 'Shipping: France €7.90 (free over €99) · Europe €19 · Switzerland €29 · rest of the world €49.') + '</p>';
    }
    form.parentNode.insertBefore(bar, form);
    var checkout = form.querySelector('button[name="checkout"]');
    if (checkout) {
      var ul = document.createElement('ul');
      ul.className = 'eb-cart-trust';
      ul.innerHTML = fr
        ? '<li>Paiement sécurisé</li><li>Expédié sous 24/48 h</li><li>Satisfait ou remboursé</li>'
        : '<li>Secure payment</li><li>Shipped within 24-48 h</li><li>Money-back guarantee</li>';
      var back = document.createElement('a');
      back.className = 'eb-cart-back';
      back.href = (fr ? '' : '/en') + '/collections/jeux-echecs';
      back.textContent = fr ? '← Continuer mes achats' : '← Continue shopping';
      checkout.parentNode.appendChild(ul);
      checkout.parentNode.appendChild(back);
    }
  }

  ready(function () {
    try { initPdp(); } catch (e) {}
    try { initCartExtras(); } catch (e) {}
    try { initPills(); } catch (e) {}
    try { initCartBar(); } catch (e) {}
    try { initBlogMore(); } catch (e) {}
    try { initClamp(); } catch (e) {}
  });
})();
